module.exports = __webpack_public_path__ + "static/3-89c478ed918b961be608d9af21de574f.jpg";